<template>
  <div class="login">
    <!-- <particles></particles> -->
    <!-- <div class="login-title">{{ $t("Login.title") }}</div> -->
    <div class="login-lang">
      <el-select v-model="myVal" @change="changeLanguage" class="leftBack-select">
        <el-option v-for="item in language" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="login-form">
      <div class="form-title">{{ $t("Login.titleName") }}</div>
      <div class="form-name">{{ $t("Login.title") }}</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
        <el-form-item prop="loginName">
          <el-input prefix-icon="el-icon-user" v-model="ruleForm.loginName"
            :placeholder="$t('Login.loginName')"></el-input>
        </el-form-item>
        <el-form-item prop="loginPwd">
          <el-input prefix-icon="el-icon-lock" type="password" v-model="ruleForm.loginPwd"
            :placeholder="$t('Login.loginPwd')"></el-input>
        </el-form-item>
        <el-form-item class="form-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">{{
            $t("Login.login")
            }}</el-button>
        </el-form-item>
        <!-- <p class="form-pass">{{ $t("Login.forgetPass") }}</p> -->
      </el-form>
    </div>
    <div class="login-icon">
      <el-popover placement="left" trigger="hover">
        <div>
          <div style="padding: 10px 5px 10px 10px">
            <img src="../assets/images/zjScan.png" style="width: 133px" />
            <p style="text-align: center">安卓APP</p>
          </div>
          <!-- <div style="padding: 10px 5px 10px 10px">
          <img src="../assets/images/iosImg.png" style="width: 133px" />
          <p style="text-align: center">苹果APP</p>
        </div> -->
        </div>
        <el-button slot="reference"><i class="el-icon-mobile-phone"></i></el-button>
      </el-popover>
    </div>
    <!-- <div class="login-record">
       ©CopyRight 2019-2024
      <a
        target="_blank"
        href="https://beian.miit.gov.cn"
        style="
          display: inline-block;
          text-decoration: none;
          color: #fff;
          padding: 0 10px;
        "
        >皖ICP备20002469号-1</a
      >
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34012302001189"
        style="display: inline-block; text-decoration: none"
        ><img
          src="../assets/images/china.png"
          style="width: 16px; vertical-align: bottom"
        />
        <span
          style="
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #fff;
          "
        >
          皖公网安备 34012302001189号
        </span></a
      >
    </div> -->
  </div>
</template>

<script>
import Particles from "@/components/particles/index";
export default {
  name: "Login",
  components: { Particles },
  data() {
    return {
      ruleForm: {
        loginName: "",
        loginPwd: "",
      },
      rules: {
        loginName: [
          {
            required: true,
            message: this.$t("Login.loginNameMessage"),
            trigger: "blur",
          },
        ],
        loginPwd: [
          {
            required: true,
            message: this.$t("Login.loginPwdMessage"),
            trigger: "blur",
          },
        ],
      },
      myVal: 0,
      language: [
        { label: "中文", value: 0 },
        { label: "English", value: 1 },

      ],
      longitude: "",
      latitude: "",
    };
  },
  created() {
    if (localStorage.getItem("locale") == "zh") {
      this.$i18n.locale = "zh";
      this.myVal = 0;
    } else {
      this.$i18n.locale = "en";
      this.myVal = 1;
    }
  },
  methods: {
    changeLanguage(e) {
      if (e === 0) {
        this.$i18n.locale = "zh";
        this.myVal = 0;
      } else {
        this.$i18n.locale = "en";
        this.myVal = 1;
      }
      localStorage.setItem("locale", this.$i18n.locale);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            loginName: this.ruleForm.loginName,
            loginPwd: this.ruleForm.loginPwd,
          };
          this.$store
            .dispatch("Login/GET_LOGIN", param)
            .then((res) => {
              console.log(res.data);
              if (res.data.code == 200) {
                sessionStorage.setItem("token", res.data.data.token);
                sessionStorage.setItem("username", res.data.data.userName);
                sessionStorage.setItem(
                  "menu",
                  JSON.stringify(res.data.data.powerManagePO)
                );
                const permissinosMenu = res.data.data.powerManagePO;
                const buttonPermiss = permissinosMenu.filter((item) => {
                  console.log(item)
                  return item.nodeType === 2;
                });
                console.log(buttonPermiss);
                sessionStorage.setItem(
                  "buttonPermiss",
                  JSON.stringify(buttonPermiss)
                );
                console.log(sessionStorage.getItem("buttonPermiss"))
                sessionStorage.setItem("companyId", res.data.data.companyId);
                sessionStorage.setItem("roleData", res.data.data.roleData);
                sessionStorage.setItem("userId", res.data.data.id);
                sessionStorage.setItem("mapLevel", res.data.data.mapLevel);
                sessionStorage.setItem("lng", res.data.data.longitude);
                sessionStorage.setItem("lat", res.data.data.latitude);
                sessionStorage.setItem("logo", res.data.data.logo);
                sessionStorage.setItem("path", res.data.data.homepageUrl);
                sessionStorage.setItem(
                  "jurisdictionNum",
                  res.data.data.jurisdictionNum
                );
                sessionStorage.setItem("userType", res.data.data.userType);
                let routePath = "";
                if (sessionStorage.getItem("userType") == 0) {
                  routePath = "/VehicleManagement/VehicleFiles";
                } else {
                  routePath = "/GovernmentRegulation/JurisdictionalCompanies";
                }
                this.$router.push(routePath);
                this.getLocation();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(() => { });
        } else {
          return false;
        }
      });
    },
    getLocation() {
      return new Promise((resolve, reject) => {
        var geolocation1 = new window.BMapGL.Geolocation();
        // 开启辅助定位
        geolocation1.enableSDKLocation();
        geolocation1.getCurrentPosition(function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            sessionStorage.setItem("longitude", r.point.lng);
            sessionStorage.setItem("latitude", r.point.lat);
          } else {
            //防止出现定位不存在的情况
            sessionStorage.setItem("longitude", 117.201057);
            sessionStorage.setItem("latitude", 31.693614);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  background: url("../assets/images/bgZj.png") no-repeat;
  background-size: 100% 100%;

  .login-title {
    position: absolute;
    top: 180px;
    left: 120px;
    font-size: 36px;
    background: linear-gradient(to right, #40ffef 0%, #4f74f7 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .login-lang {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 100px;

    .leftBack-select {
      width: 100px;
      padding-right: 10px;

      /deep/.el-input__inner {
        height: 30px;
        line-height: 30px;
        background-color: transparent;
        color: #333;
        border: 1px solid #333;
        border-radius: 2px;
        padding: 0 10px;
      }

      /deep/.el-input__icon {
        height: 30px;
        line-height: 30px;
      }

      /deep/.el-select__caret {
        color: #333;
      }
    }
  }

  .login-form {
    position: absolute;
    top: 50%;
    left: 60%;
    margin: -250px 0 0 0;
    width: 430px;
    height: 450px;
    // border: 2px solid rgba(255, 255, 255, 0.4);
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 50px;

    .form-title {
      color: #000;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      margin: 50px 0 10px;
    }

    .form-name {
      color: #000;
      font-size: 20px;
      font-weight: 400;
      text-align: center;
    }

    .demo-ruleForm {
      margin-top: 40px;

      /deep/.el-input__inner {
        background-color: #fff;
        border: 1px solid #E5E5E5;
        border-radius: 6px;
        // border-bottom: 1px solid #fff;
        // padding: 0;
        color: #333;
      }

      ::-webkit-input-placeholder {
        color: #C0C4CC;
        font-size: 14px;
      }

      /deep/.el-form-item__error {
        color: #fd5f72;
      }

      /deep/.el-form-item.is-error .el-input__inner,
      /deep/.el-form-item.is-error .el-input__inner:focus {
        border-color: #84848d;
      }

      .form-btn {
        margin: 60px 0 0;

        button {
          width: 330px;
          height: 40px;
          font-size: 16px;
          color: #fff;
          border-color: #EAA132;
          background-color: #EAA132;
        }

        button:hover {
          background-color: #EAA132;
          border-color: #EAA132;
        }
      }

      .form-pass {
        text-align: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
        margin-top: 10px;
      }
    }
  }

  .login-record {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 14px;
  }

  .login-icon {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-50%, -50%);

    .el-button {
      background-color: #EAA132;
      padding: 30px 10px;
      border: none;
    }

    .el-icon-mobile-phone:before {
      color: #fff;
      font-size: 30px;
    }
  }
}
</style>
